import React from "react";
import '../../static/fonts/fonts.css';
import './LayoutMain.css';
import FooterAllGatsby from "./FooterAll/FooterAll";
import HeaderAllGatsby from "./HeaderAll/HeaderAll";
import MainMenu from "./HeaderAll/MainMenu/MainMenu";
import {Helmet} from "react-helmet";
const PRERENDER_TEXTS = require("../../../prerender_base.js");


function LayoutMain(props) {

    return (
        <div className="LayoutMain ">

            <Helmet>
                <title>{props.title ? props.title[props.lang] : ''}</title>
                <meta name="description" content={props.description ? props.description[props.lang] : ''}/>
            </Helmet>
            <HeaderAllGatsby lang={props.lang} Active={props.Active} PrerenderTexts={PRERENDER_TEXTS["LayoutMain"]}/>
            <MainMenu Active={props.Active} lang={props.lang} AllMenu={props.AllMenu}/>
            {props.children}
            <FooterAllGatsby lang={props.lang} in404={props.in404}/>
        </div>
    )}


export default LayoutMain

